var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"select-tool",attrs:{"title":_vm.title}},[_c('ui-select',_vm._b({staticClass:"w-100",on:{"change":_vm.onChange}},'ui-select',{
            value: _vm.value,
            options: _vm.options,
            valueObjects: _vm.valueObjects,
            disabled: !_vm.isEnabled,
            size: 'small',
            appendToBody: false
        },false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }